// Charge la base commune
import './common.js'

// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}

// Masonry
async function getMasonry () {
  /* global Waypoint */
  import(/* webpackChunkName: "masonry" */ './js/components/masonry.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe" */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du masonry
  const $m = $('.grid')
  if ($m.length) {
    $m.waypoint(function () {
      getMasonry()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $g = $('.gallery')
  if ($g.length) {
    $g.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
